import { Terms } from '@/screens/terms';

export default function TermsScreen() {
  return <Terms />;
}
